import { useAuth } from '../context/AuthContext';
import { useAppData } from '../context/AppDataContext';
import { permissionService } from '../services/permissionService';

export const usePermissions = () => {
  const { user } = useAuth();
  const { permissions, loadingPermissions } = useAppData();

  const hasPermission = (resource: string, action: string): boolean => {
    // Org admin always has all permissions
    if (user?.role === 'org_admin') {
      return true;
    }

    if (!permissions) {
      return false;
    }

    return permissionService.hasPermission(permissions.permissions, resource, action);
  };

  const hasAnyPermission = (checks: Array<{ resource: string; action: string }>): boolean => {
    // Org admin always has all permissions
    if (user?.role === 'org_admin') {
      return true;
    }

    if (!permissions) {
      return false;
    }

    return permissionService.hasAnyPermission(permissions.permissions, checks);
  };

  return {
    permissions,
    loading: loadingPermissions,
    hasPermission,
    hasAnyPermission,
    isOrgAdmin: user?.role === 'org_admin'
  };
};


